export default __webpack_public_path__ + "static/media/General-Practitioners.82f93a2d.png";